
import React from "react";
import { Card, CardContent } from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import classnames from "classnames";

export class EnfardadorDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.styles = props.styles;
  }

  renderEnfardadorCard(user) {
    return (
      <Card>
        <CardContent>
          <div className={classnames(this.styles.grid)}>
            <Grid container spacing={24}>
              <Grid item xs={2}>
                <AccountCircle style={this.styles.icon} />
              </Grid>
              <Grid item xs={10} style={this.styles.cardContent.user}>
                <div style={{ textTransform: "capitalize" }}>{user.nombre}</div>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={3} style={this.styles.cardContent.prop}>
                <div>D.N.I.</div>
              </Grid>
              <Grid item xs={9} style={this.styles.cardContent.value}>
                <div>{user.dni}</div>
              </Grid>
            </Grid>
          </div>
        </CardContent>
      </Card>
    );
  }

  render() {
    const { user } = this.props;
    return this.renderEnfardadorCard(user);
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/Enfardador.js